import { WSSelectOption } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

export const getLimitOptions = <I extends any>(options: I[], common: I) => {
  return options.map(value => ({
    value: `${value}`,
    label: `${typeof value === "number" ? formatMoney(value, "USD") : "–"} ${
      common === value ? "(most common)" : ""
    }`
  })) as WSSelectOption[];
};
